import { Component, OnInit } from '@angular/core';
import { BlogService } from '../../service/blog.service';
import { ConfigurationHelper } from '../../generic/helper/configuration.helper';
import { BlogPage } from './blog.page';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Logger } from '../../generic/logging/default-log.service';
import { NgClass } from '@angular/common';

/**
 * Renders a simple list of blogs, based on the list cached in the backend.
 *
 * @author evandongen
 */
@Component({
    selector: 'blog-list',
    templateUrl: 'blog.list.component.html',
    standalone: true,
    imports: [NgClass, RouterLink],
})
export class BlogListComponent implements OnInit {
    blogPage: BlogPage;
    currentBlogPage: number = 1;

    constructor(
        private blogService: BlogService,
        private logger: Logger,
        private route: ActivatedRoute,
    ) {
        this.getBlogsForPage();
    }

    ngOnInit(): void {
        const pageNumber = this.route.snapshot.paramMap.get('page');
        if (pageNumber !== null) {
            // By using the unary '+' operator we force the value to be a number.
            // By ending the value with a '!' we let typescript know the page param is always a value instead of null
            this.currentBlogPage = +pageNumber!;
        }
    }

    getBlogsForPage() {
        this.blogService
            .getBlogs(this.currentBlogPage)
            .then(result => {
                this.blogPage = result.blogPage;
            })
            .catch(error => {
                this.logger.error(
                    'Error loading the blog items from the site',
                    error,
                );
            });
    }

    hasValidCmsRelativeUrl(imageUrl: string): boolean {
        return !!imageUrl;
    }

    getCmsUrl(relativeUrl: string): string {
        return ConfigurationHelper.getWebsiteUrl(relativeUrl);
    }

    getBlogItemSize(index: number): string {
        const itemSize = index % 5 === 0 || index % 5 === 1 ? 'large' : 'small';
        return `blog-overview-item--${itemSize}`;
    }
}
